import Alpine from "alpinejs";

import { fetchCart, updateVariantQuantity } from "../../_api/cart";

const { CART } = window;

export const alpineStoreCart = () =>
  Alpine.store("cartState", {
    cart: CART || null,
    pendingUpdateVariantId: null,
    isCartUpdating: false,
    isNavigatingToCheckout: false,

    init() {
      if (location.search === "?viewcart=true") {
        this.isCartDrawerOpen = true;
      }

      if (location.hash) {
        addEventListener("DOMContentLoaded", () => {
          setTimeout(() => {
            // sometimes shopify caches the cart, so we need to refresh it from the API
            this.fetchCart();
          }, 1000);
        });
      }
    },

    /**
     * Updates the quantity of a specific variant and updates the cart state.
     *
     * @param {number} variantId - The ID of the variant to update.
     * @param {number} quantity - The new quantity for the variant.
     */
    async updateVariantQuantity(variantId, quantity) {
      this.pendingUpdateVariantId = variantId;

      try {
        const response = await updateVariantQuantity(variantId, quantity);
        if (!response.ok) {
          const errorBody = await response.json();
          const errorMessage =
            errorBody.description ||
            errorBody.message ||
            `Error updating quantity: ${response.status} ${response.statusText}`;
          alert(errorMessage);
          throw new Error(errorMessage);
        }

        this.cart = await response.json();
      } catch (error) {
        console.error("Failed to update variant quantity:", error.message);
      } finally {
        this.pendingUpdateVariantId = null;
      }
    },

    /**
     * Navigates to the checkout page if the cart is not currently being updated.
     * Prevents navigation and warns the user if updates are pending.
     *
     * @param {Event} event - The event triggered by the checkout navigation action.
     */
    async navigateToCheckout(event) {
      if (this.isCartUpdating || this.pendingUpdateVariantId) {
        console.warn("Cart is updating. Navigation to checkout is blocked.");
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      this.isNavigatingToCheckout = true;
      window.location.href = "/checkout";

      setTimeout(() => {
        this.isNavigatingToCheckout = false;
      }, 1000);
    },

    /**
     * Fetches the cart from the server and updates the local cart state.
     * Sets the isCartUpdating flag to false once the operation is complete.
     */
    async fetchCart() {
      this.isCartUpdating = true;

      try {
        const response = await fetchCart();
        const cart = await response.json();
        this.cart = cart;
      } catch (error) {
        console.error("Failed to fetch cart:", error);
        throw error;
      } finally {
        this.isCartUpdating = false;
      }
    },
  });
